require('./brokerRequestFinancialOperationChangeView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('commonsComponents/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

// @components
const BrokerRequestFinancialOperationChangeStep1 = require('components/broker/brokerRequestFinancialOperationChange/brokerRequestFinancialOperationChangeStep1/brokerRequestFinancialOperationChangeStep1');
const BrokerRequestFinancialOperationChangeStep2 = require('components/broker/brokerRequestFinancialOperationChange/brokerRequestFinancialOperationChangeStep2/brokerRequestFinancialOperationChangeStep2');
const BrokerRequestFinancialOperationChangeSuccess = require('components/broker/brokerRequestFinancialOperationChange/brokerRequestFinancialOperationChangeSuccess/brokerRequestFinancialOperationChangeSuccess');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @helpers
const { formatText, FormattedText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject, formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { getDocumentURL } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');

// @actions
const BrokerRequestFinancialOperationChangeActions = require('actions/brokerRequestFinancialOperationChange');
const productFileActions = require('actions/brokerGetProductFile');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_SECOND_STEP,
    MYPROFILE_BROKER_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_TYPE_RIGHT_NEW_DECIMALS,
    DATE_FORMAT_ES,
    EURO_TEXT,
    BROKER_BUY_SCREEN
} = require('constants/index');
const { CHARGE_ACCOUNT_PREFIX } = require('constants/index');

class BrokerRequestFinancialOperationChangeView extends React.Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.buildWizard = this.buildWizard.bind(this);
        this.buildSideColumn = this.buildSideColumn.bind(this);
        this.buildSuccess = this.buildSuccess.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.breadcrumb = [
            {
                text: formatText('broker-myWallet'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('requestFinancialOperationChange-corporateOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            },
            {
                text: formatText('requestFinancialOperationChange-changesConversionsRequestChange'),
                url: ''
            }
        ];
    }

    componentWillMount() {
        const { immBrokerRequestFinancialOperationChange, immCorporatesOperations, getProductFile, history } = this.props;
        const index = immBrokerRequestFinancialOperationChange.get('selectedCorporateOperationIndex');
        const isLoaded = immBrokerRequestFinancialOperationChange.get('isLoaded');

        if (!isLoaded) {
            history.push(BROKER_CORPORATE_OPERATIONS_URL);
        } else if (index >= 0 && immCorporatesOperations.getIn(['selectedContract', 'operations', index])) {
            const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', index]);
            const isin = selectedCorporateOperation.get('isin');
            const iso = selectedCorporateOperation.get('iso');
            getProductFile(isin, iso, BROKER_BUY_SCREEN);
        }
    }

    componentWillReceiveProps(newProps) {
        const { immBrokerRequestFinancialOperationChange, onSubmitOperation, history } = newProps;
        const fetchConfirmOrder = this.props.immBrokerRequestFinancialOperationChange.get('fetchConfirmOrder');
        const finished = immBrokerRequestFinancialOperationChange.get('finished');
        const visibleStep = immBrokerRequestFinancialOperationChange.get('visibleStep');
        const acceptedManifest = immBrokerRequestFinancialOperationChange.getIn(['steps', visibleStep - 1, 'acceptedManifest']);
        const visibleStepValid = immBrokerRequestFinancialOperationChange.getIn(['steps', visibleStep - 1, 'valid']);
        const visibleStepLast = visibleStep === immBrokerRequestFinancialOperationChange.get('steps').size;

        if (visibleStepValid && acceptedManifest && !finished) {
            if (visibleStepLast) {
                if(fetchConfirmOrder !== newProps.immBrokerRequestFinancialOperationChange.get('fetchConfirmOrder')) {
                    onSubmitOperation(history);
                }
            }
        }
    }

    buildSideColumn() {
        const { immBrokerRequestFinancialOperationChange, immProductFile } = this.props;
        const contrato = immBrokerRequestFinancialOperationChange.get('contrato');
        const contractId = CHARGE_ACCOUNT_PREFIX + contrato.get('product') + contrato.get('number');
        const immCuentaAsociada = immBrokerRequestFinancialOperationChange.get('cuentaAsociada');
        const associatedAccountBalance = immCuentaAsociada.get('balance');
        const endDate = DateHelper.buildFormattedDate(immBrokerRequestFinancialOperationChange.getIn(['valor', 'endDate']), DATE_FORMAT_ES);
        const plainAmountObject = getPlainAmountObject(associatedAccountBalance);
        const language = getLanguage();
        const titlesAmount = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP, 'titlesAmount']);
        const visibleStep = immBrokerRequestFinancialOperationChange.get('visibleStep');
        const quotationValue = immProductFile.getIn(['productValue', 'amount'], 0);
        const quotationAmount = formatAmount(quotationValue, getLanguage(), BROKER_TYPE_RIGHT_NEW_DECIMALS);
        const currency = formatCurrency(EURO_TEXT); // @hardcoded
        let titleAmountSection;
        if (visibleStep === WIZARD_SECOND_STEP) {
            titleAmountSection = (
                <div className="broker-request-financial-operation-change-view__sidecolumn-information">
                    <h5 className="broker-request-financial-operation-change-view__sidecolumn-information-title">
                        <FormattedText
                            value="requestFinancialOperationChange-titleNumber"
                            format="uppercase"
                        />
                    </h5>
                    <div className="broker-request-financial-operation-change-view__sidecolumn-information-primary-text">
                        {titlesAmount}
                    </div>
                </div>
            );
        }

        return (
            <OKSectionBox>
                <h4 className="broker-request-financial-operation-change-view__sidecolumn-header-value"><FormattedText value="requestFinancialOperationChange-value" /></h4>

                <div className="broker-request-financial-operation-change-view__sidecolumn-header">
                    <h3 className="broker-request-financial-operation-change-view__sidecolumn-header-title">{immBrokerRequestFinancialOperationChange.getIn(['valor', 'descriptionValue'])}</h3>
                </div>

                <div className="broker-request-financial-operation-change-view__sidecolumn-information">
                    <h5 className="broker-request-financial-operation-change-view__sidecolumn-information-title">
                        <FormattedText
                            value="requestFinancialOperationChange-contract"
                            format="uppercase"
                        />
                    </h5>
                    <div className="broker-request-financial-operation-change-view__sidecolumn-information-primary-text">
                        {immBrokerRequestFinancialOperationChange.get('contract')}
                    </div>
                    <div className="broker-request-financial-operation-change-view__lighter-fg">
                        (<FormattedText
                            value="requestFinancialOperationChange-number"
                            injectedStrings={[contractId]}
                        />)
                    </div>
                </div>

                <div className="broker-request-financial-operation-change-view__sidecolumn-information">
                    <h5 className="broker-request-financial-operation-change-view__sidecolumn-information-title">
                        <FormattedText
                            value="requestFinancialOperationChange-owner"
                            format="uppercase"
                        />
                    </h5>
                    <div className="broker-request-financial-operation-change-view__sidecolumn-information-primary-text">
                        {immBrokerRequestFinancialOperationChange.get('contractOwner')}
                    </div>
                    <div className="broker-request-financial-operation-change-view__lighter-fg">
                        (<FormattedText value="requestFinancialOperationChange-authorized" />)
                    </div>
                </div>

                <div className="broker-request-financial-operation-change-view__sidecolumn-information">
                    <h5 className="broker-request-financial-operation-change-view__sidecolumn-information-title">
                        <FormattedText
                            value="requestFinancialOperationChange-associatedAccount"
                            format="uppercase"
                        />
                    </h5>
                    <div className="broker-request-financial-operation-change-view__sidecolumn-information-primary-text">
                        {immCuentaAsociada.get('number')}
                    </div>
                    <div className="broker-request-financial-operation-change-view__lighter-fg">
                        (
                        <FormattedText
                            value="requestFinancialOperationChange-associatedAccountBalance"
                        />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                        )
                    </div>
                </div>

                <div className="broker-request-financial-operation-change-view__sidecolumn-information">
                    <h5 className="broker-request-financial-operation-change-view__sidecolumn-information-title">
                        <FormattedText
                            value="broker-rightsQuotation"
                            format="uppercase"
                        />
                    </h5>
                    <div className="broker-request-financial-operation-change-view__sidecolumn-information-primary-text">
                        {quotationAmount} {currency}
                    </div>
                </div>

                <div className="broker-request-financial-operation-change-view__sidecolumn-information">
                    <h5 className="broker-request-financial-operation-change-view__sidecolumn-information-title">
                        <FormattedText
                            value="broker-rightsBuySidebarDeadlineLabel"
                            format="uppercase"
                        />
                    </h5>
                    <div className="broker-request-financial-operation-change-view__sidecolumn-information-primary-text">
                        {endDate}
                    </div>
                </div>
                {titleAmountSection}
            </OKSectionBox>
        );
    }

    buildSuccess() {
        const { immBrokerRequestFinancialOperationChange } = this.props;

        return (
            <BrokerRequestFinancialOperationChangeSuccess
                immBrokerRequestFinancialOperationChange={immBrokerRequestFinancialOperationChange}
            />
        );
    }

    handleCancel() {
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_URL);
    }

    buildWizard() {
        const {
            immBrokerRequestFinancialOperationChange,
            immCorporatesOperations,
            onConfirmOperationCheckbox,
            onChangeTitlesAmount,
            validateStep,
            setVisibleStep,
            setWillCancel,
            setDocumentsRead
        } = this.props;
        const immSteps = immBrokerRequestFinancialOperationChange.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immBrokerRequestFinancialOperationChange.get('visibleStep');
        const wizardClass = 'broker-request-financial-operation-change-view__wizard';
        const immFinalButton = 'requestFinancialOperationChange-request';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleSubmit,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                >
                    <BrokerRequestFinancialOperationChangeStep1
                        immBrokerRequestFinancialOperationChange={immBrokerRequestFinancialOperationChange}
                        immCorporatesOperations={immCorporatesOperations}
                        onChangeTitlesAmount={onChangeTitlesAmount}
                        breadcrumb={this.breadcrumb}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <BrokerRequestFinancialOperationChangeStep2
                        immBrokerRequestFinancialOperationChange={immBrokerRequestFinancialOperationChange}
                        onConfirmOperationCheckbox={onConfirmOperationCheckbox}
                        setDocumentsRead={setDocumentsRead}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleSubmit() {
        const { history, onSubmitOperation, immBrokerRequestFinancialOperationChange } = this.props;
        const acceptedManifest = immBrokerRequestFinancialOperationChange.getIn(['steps', SECOND_STEP, 'acceptedManifest']);
        if (acceptedManifest) {
            onSubmitOperation(history);
        }
    }

    render() {
        const { immBrokerRequestFinancialOperationChange, immVariables } = this.props;
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        let content;

        if (immBrokerRequestFinancialOperationChange.get('finished')) {
            content = this.buildSuccess();
        } else {
            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        return (
            <section className="broker-request-financial-operation-change-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.breadcrumb}
                        subtitleLeft={formatText('requestFinancialOperationChange-subtitle')}
                        isSubtitleLeftCapital={false}
                        finalTitle={getFinalTitle('requestFinancialOperationChange-title')}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            onClick={() => window.open(fees_url, '_blank')}
                        >
                            <FormattedText value="requestFinancialOperationChange-commissions" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-request-financial-operation-change-view__body">
                    {content}
                </section>
            </section>
        );
    }
}

BrokerRequestFinancialOperationChangeView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerRequestFinancialOperationChange: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    onConfirmOperationCheckbox: PropTypes.func.isRequired,
    onSubmitOperation: PropTypes.func.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    getProductFile: PropTypes.func.isRequired,
    immProductFile: PropTypes.object.isRequired,
    setDocumentsRead: PropTypes.object.isRequired
};

module.exports.constructor = BrokerRequestFinancialOperationChangeView;
module.exports.BrokerRequestFinancialOperationChangeView = connect(
    (state) => ({
        immBrokerRequestFinancialOperationChange: state.brokerRequestFinancialOperationChange,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immProductFile: state.brokerProductFile,
        immVariables: state.globalVariables
    }),
    {
        onConfirmOperationCheckbox: BrokerRequestFinancialOperationChangeActions.confirmOperationCheckbox,
        onSubmitOperation: BrokerRequestFinancialOperationChangeActions.submitOperation,
        onChangeTitlesAmount: BrokerRequestFinancialOperationChangeActions.changeTitlesAmount,
        validateStep: BrokerRequestFinancialOperationChangeActions.validateStep,
        setVisibleStep: BrokerRequestFinancialOperationChangeActions.setVisibleStep,
        setWillCancel: BrokerRequestFinancialOperationChangeActions.setWillCancel,
        getProductFile: productFileActions.getProductFile,
        setDocumentsRead: BrokerRequestFinancialOperationChangeActions.setDocumentsRead
    }
)(withRouter(BrokerRequestFinancialOperationChangeView));
